// /home/labdoo/zitech-nexus/frontend/src/pages/AnnouncementManagement.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { announcementAPI } from '../services/api';
import './AnnouncementManagement.css';

// SVG Icons
const Icons = {
  Announcement: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" />
      <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" />
      <path d="M8 11L12 8L16 11" />
      <path d="M8 15L12 12L16 15" />
    </svg>
  ),
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M12 5V19M5 12H19" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Delete: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7H20" />
      <path d="M10 11V16" />
      <path d="M14 11V16" />
      <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" />
      <path d="M9 7L10 3H14L15 7" />
    </svg>
  ),
  StatusActive: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" fill="currentColor" />
    </svg>
  ),
  StatusInactive: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
    </svg>
  ),
  PriorityHigh: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="2" x2="12" y2="22" />
      <polyline points="7 7 12 2 17 7" />
    </svg>
  ),
  PriorityMedium: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="2" x2="12" y2="22" />
    </svg>
  ),
  PriorityLow: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="2" x2="12" y2="22" />
      <polyline points="17 17 12 22 7 17" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12L11 15L16 9" />
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Info: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Success: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12L11 15L16 9" />
    </svg>
  ),
  Warning: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 22H22L12 2Z" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <circle cx="12" cy="16" r="1" fill="#f59e0b" />
    </svg>
  ),
  Error: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="8" y1="8" x2="16" y2="16" />
      <line x1="16" y1="8" x2="8" y2="16" />
    </svg>
  ),
  Promotion: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L15 9H22L16.5 14L18.5 21L12 16.5L5.5 21L7.5 14L2 9H9L12 2Z" />
    </svg>
  ),
  ImageUpload: () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="am-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
};

const AnnouncementManagement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingAnnouncement, setEditingAnnouncement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    message: '',
    icon: '',
    image: null,
    link: '',
    link_text: 'Learn More',
    type: 'info',
    is_active: true,
    priority: 'medium',
    start_date: new Date().toISOString().split('T')[0],
    end_date: ''
  });
  const [toast, setToast] = useState({ show: false, message: '', type: '' });

  const showToast = useCallback((message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  }, []);

  const fetchAnnouncements = useCallback(async () => {
    setLoading(true);
    try {
      const response = await announcementAPI.getAll();
      const data = response.data || [];
      setAnnouncements(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching announcements:', error);
      showToast('Failed to load announcements', 'error');
      setAnnouncements([]);
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  useEffect(() => {
    fetchAnnouncements();
  }, [fetchAnnouncements]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        showToast('Image size must be less than 5MB', 'error');
        return;
      }
      
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        showToast('Please upload a valid image (JPEG, PNG, GIF, WEBP)', 'error');
        return;
      }
      
      setFormData({
        ...formData,
        image: file
      });
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setFormData({
      ...formData,
      image: null
    });
    setImagePreview(null);
    const fileInput = document.getElementById('image-upload');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const resetForm = useCallback(() => {
    setFormData({
      title: '',
      message: '',
      icon: '',
      image: null,
      link: '',
      link_text: 'Learn More',
      type: 'info',
      is_active: true,
      priority: 'medium',
      start_date: new Date().toISOString().split('T')[0],
      end_date: ''
    });
    setImagePreview(null);
    setEditingAnnouncement(null);
    setShowForm(false);
    document.body.style.overflow = 'auto';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.message) {
      showToast('Please fill in all required fields', 'error');
      return;
    }

    setLoading(true);
    try {
      const submitData = new FormData();
      submitData.append('title', formData.title);
      submitData.append('message', formData.message);
      if (formData.icon) submitData.append('icon', formData.icon);
      if (formData.image) submitData.append('image', formData.image);
      if (formData.link) submitData.append('link', formData.link);
      submitData.append('link_text', formData.link_text || 'Learn More');
      submitData.append('type', formData.type);
      submitData.append('priority', formData.priority);
      submitData.append('is_active', formData.is_active);
      submitData.append('start_date', formData.start_date ? new Date(formData.start_date).toISOString() : new Date().toISOString());
      if (formData.end_date) submitData.append('end_date', new Date(formData.end_date).toISOString());

      if (editingAnnouncement) {
        await announcementAPI.update(editingAnnouncement.id, submitData);
        showToast('Announcement updated successfully!', 'success');
      } else {
        await announcementAPI.create(submitData);
        showToast('Announcement created successfully!', 'success');
      }

      await fetchAnnouncements();
      resetForm();
    } catch (error) {
      console.error('Error saving announcement:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          JSON.stringify(error.response?.data) ||
                          'Failed to save announcement';
      showToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (announcement) => {
    setEditingAnnouncement(announcement);
    setFormData({
      title: announcement.title,
      message: announcement.message,
      icon: announcement.icon || '',
      image: null,
      link: announcement.link || '',
      link_text: announcement.link_text || 'Learn More',
      type: announcement.type || 'info',
      is_active: announcement.is_active,
      priority: announcement.priority || 'medium',
      start_date: announcement.start_date?.split('T')[0] || new Date().toISOString().split('T')[0],
      end_date: announcement.end_date?.split('T')[0] || ''
    });
    setImagePreview(announcement.image_url || null);
    setShowForm(true);
    document.body.style.overflow = 'hidden';
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this announcement?')) {
      setLoading(true);
      try {
        await announcementAPI.delete(id);
        showToast('Announcement deleted successfully!', 'success');
        await fetchAnnouncements();
      } catch (error) {
        console.error('Error deleting announcement:', error);
        showToast('Failed to delete announcement', 'error');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleToggleStatus = async (id) => {
    setLoading(true);
    try {
      await announcementAPI.toggleStatus(id);
      showToast('Status updated successfully!', 'success');
      await fetchAnnouncements();
    } catch (error) {
      console.error('Error toggling status:', error);
      showToast('Failed to update status', 'error');
    } finally {
      setLoading(false);
    }
  };

  const getTypeColor = (type) => {
    const colors = {
      info: '#3b82f6',
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      promotion: '#8b5cf6'
    };
    return colors[type] || colors.info;
  };

  const getTypeBackground = (type) => {
    const colors = {
      info: '#dbeafe',
      success: '#d1fae5',
      warning: '#fef3c7',
      error: '#fee2e2',
      promotion: '#ede9fe'
    };
    return colors[type] || colors.info;
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      high: 'High',
      medium: 'Medium',
      low: 'Low'
    };
    return labels[priority] || priority;
  };

  const getTypeLabel = (type) => {
    const labels = {
      info: 'Info',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
      promotion: 'Promotion'
    };
    return labels[type] || type;
  };

  const getTypeIcon = (type) => {
    switch(type) {
      case 'info': return <Icons.Info />;
      case 'success': return <Icons.Success />;
      case 'warning': return <Icons.Warning />;
      case 'error': return <Icons.Error />;
      case 'promotion': return <Icons.Promotion />;
      default: return <Icons.Info />;
    }
  };

  const getPriorityIcon = (priority) => {
    switch(priority) {
      case 'high': return <Icons.PriorityHigh />;
      case 'medium': return <Icons.PriorityMedium />;
      case 'low': return <Icons.PriorityLow />;
      default: return <Icons.PriorityMedium />;
    }
  };

  const announcementList = Array.isArray(announcements) ? announcements : [];

  return (
    <div className="am-container">
      {/* Toast Notification */}
      {toast.show && (
        <div className={`am-toast ${toast.type}`}>
          <span className="am-toast-icon">
            {toast.type === 'success' ? <Icons.Success /> : <Icons.Error />}
          </span>
          <span className="am-toast-message">{toast.message}</span>
          <button className="am-toast-close" onClick={() => setToast({ show: false, message: '', type: '' })}>
            <Icons.Close />
          </button>
        </div>
      )}

      {/* Header */}
      <div className="am-header">
        <div className="am-header-left">
          <h1 className="am-title">
            <Icons.Announcement />
            Announcement Management
          </h1>
          <p className="am-subtitle">Create and manage announcements for your website</p>
        </div>
        <button 
          className="am-btn-primary"
          onClick={() => {
            resetForm();
            setShowForm(true);
            document.body.style.overflow = 'hidden';
          }}
          disabled={loading}
        >
          <Icons.Plus />
          New Announcement
        </button>
      </div>

      {/* Stats Bar */}
      <div className="am-stats-bar">
        <div className="am-stat-item">
          <span className="am-stat-label">Total</span>
          <span className="am-stat-value">{announcementList.length}</span>
        </div>
        <div className="am-stat-divider"></div>
        <div className="am-stat-item">
          <span className="am-stat-label">Active</span>
          <span className="am-stat-value am-stat-active">{announcementList.filter(a => a.is_active).length}</span>
        </div>
        <div className="am-stat-divider"></div>
        <div className="am-stat-item">
          <span className="am-stat-label">Inactive</span>
          <span className="am-stat-value am-stat-inactive">{announcementList.filter(a => !a.is_active).length}</span>
        </div>
      </div>

      {/* List */}
      <div className="am-list">
        <div className="am-list-header">
          <h2 className="am-list-title">All Announcements</h2>
          <span className="am-list-count">{announcementList.length} total</span>
        </div>

        {loading && announcementList.length === 0 ? (
          <div className="am-loading-container">
            <div className="am-spinner">
              <Icons.Spinner />
            </div>
            <p className="am-loading-text">Loading announcements...</p>
          </div>
        ) : announcementList.length === 0 ? (
          <div className="am-empty-state">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" />
            </svg>
            <p className="am-empty-text">No announcements yet.</p>
            <p className="am-empty-subtext">Create your first announcement to get started</p>
          </div>
        ) : (
          <div className="am-table-wrapper">
            <table className="am-table">
              <thead>
                <tr>
                  <th className="am-col-status">Status</th>
                  <th className="am-col-image">Image</th>
                  <th className="am-col-icon">Icon</th>
                  <th className="am-col-title">Title</th>
                  <th className="am-col-message">Message</th>
                  <th className="am-col-type">Type</th>
                  <th className="am-col-priority">Priority</th>
                  <th className="am-col-dates">Dates</th>
                  <th className="am-col-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {announcementList.map((announcement) => (
                  <tr key={announcement.id} className={!announcement.is_active ? 'am-row-inactive' : ''}>
                    <td className="am-col-status">
                      <button
                        className={`am-status-badge ${announcement.is_active ? 'am-status-active' : 'am-status-inactive'}`}
                        onClick={() => handleToggleStatus(announcement.id)}
                        disabled={loading}
                      >
                        {announcement.is_active ? (
                          <>
                            <Icons.StatusActive />
                            Active
                          </>
                        ) : (
                          <>
                            <Icons.StatusInactive />
                            Inactive
                          </>
                        )}
                      </button>
                    </td>
                    <td className="am-col-image">
                      {announcement.image_url ? (
                        <img 
                          src={announcement.image_url} 
                          alt={announcement.title} 
                          className="am-thumbnail"
                          loading="lazy"
                        />
                      ) : (
                        <span className="am-no-image">—</span>
                      )}
                    </td>
                    <td className="am-col-icon">{announcement.icon || '📢'}</td>
                    <td className="am-col-title">
                      <strong>{announcement.title}</strong>
                    </td>
                    <td className="am-col-message">{announcement.message}</td>
                    <td className="am-col-type">
                      <span 
                        className="am-type-badge"
                        style={{
                          background: getTypeBackground(announcement.type),
                          color: getTypeColor(announcement.type)
                        }}
                      >
                        <span className="am-type-icon">{getTypeIcon(announcement.type)}</span>
                        {getTypeLabel(announcement.type)}
                      </span>
                    </td>
                    <td className="am-col-priority">
                      <span className="am-priority-badge">
                        <span className="am-priority-icon">{getPriorityIcon(announcement.priority)}</span>
                        <span className="am-priority-text">{getPriorityLabel(announcement.priority)}</span>
                      </span>
                    </td>
                    <td className="am-col-dates">
                      <div className="am-date-info">
                        <span>
                          <Icons.Calendar />
                          From: {new Date(announcement.start_date).toLocaleDateString()}
                        </span>
                        {announcement.end_date && (
                          <span>
                            <Icons.Calendar />
                            To: {new Date(announcement.end_date).toLocaleDateString()}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="am-col-actions">
                      <div className="am-actions">
                        <button 
                          className="am-action-btn am-action-edit"
                          onClick={() => handleEdit(announcement)}
                          title="Edit"
                          disabled={loading}
                        >
                          <Icons.Edit />
                          Edit
                        </button>
                        <button 
                          className="am-action-btn am-action-delete"
                          onClick={() => handleDelete(announcement.id)}
                          title="Delete"
                          disabled={loading}
                        >
                          <Icons.Delete />
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Create/Edit Form Modal */}
      {showForm && (
        <div className="am-modal-overlay" onClick={resetForm}>
          <div className="am-modal" onClick={(e) => e.stopPropagation()}>
            <div className="am-modal-header">
              <h2 className="am-modal-title">{editingAnnouncement ? 'Edit Announcement' : 'Create New Announcement'}</h2>
              <button className="am-modal-close" onClick={resetForm}>
                <Icons.Close />
              </button>
            </div>
            <div className="am-modal-body">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="am-form-group">
                  <label className="am-form-label">Title *</label>
                  <input
                    type="text"
                    name="title"
                    className="am-form-input"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Enter announcement title"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="am-form-group">
                  <label className="am-form-label">Message *</label>
                  <textarea
                    name="message"
                    className="am-form-textarea"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Enter announcement message"
                    rows="3"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="am-form-row">
                  <div className="am-form-group">
                    <label className="am-form-label">Icon (Optional)</label>
                    <input
                      type="text"
                      name="icon"
                      className="am-form-input"
                      value={formData.icon}
                      onChange={handleInputChange}
                      placeholder="Emoji or text"
                      maxLength="10"
                      disabled={loading}
                    />
                  </div>

                  <div className="am-form-group">
                    <label className="am-form-label">Type</label>
                    <select name="type" className="am-form-select" value={formData.type} onChange={handleInputChange} disabled={loading}>
                      <option value="info">Info</option>
                      <option value="success">Success</option>
                      <option value="warning">Warning</option>
                      <option value="error">Error</option>
                      <option value="promotion">Promotion</option>
                    </select>
                  </div>

                  <div className="am-form-group">
                    <label className="am-form-label">Priority</label>
                    <select name="priority" className="am-form-select" value={formData.priority} onChange={handleInputChange} disabled={loading}>
                      <option value="high">High</option>
                      <option value="medium">Medium</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                </div>

                {/* Image Upload */}
                <div className="am-form-group">
                  <label className="am-form-label">Image (Optional)</label>
                  <div className="am-image-upload-wrapper">
                    <div className="am-image-upload-area">
                      <input
                        type="file"
                        id="image-upload"
                        name="image"
                        accept="image/jpeg,image/png,image/gif,image/webp"
                        onChange={handleImageChange}
                        disabled={loading}
                        className="am-image-input"
                      />
                      <label htmlFor="image-upload" className="am-image-label">
                        <Icons.ImageUpload />
                        <span>Click to upload image</span>
                        <span className="am-image-hint">JPEG, PNG, GIF, WEBP (Max 5MB)</span>
                      </label>
                    </div>
                    {imagePreview && (
                      <div className="am-image-preview-wrapper">
                        <img src={imagePreview} alt="Preview" className="am-image-preview" />
                        <button
                          type="button"
                          className="am-image-remove"
                          onClick={removeImage}
                          disabled={loading}
                        >
                          <Icons.Close />
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="am-form-row">
                  <div className="am-form-group">
                    <label className="am-form-label">Start Date</label>
                    <input
                      type="date"
                      name="start_date"
                      className="am-form-input"
                      value={formData.start_date}
                      onChange={handleInputChange}
                      disabled={loading}
                    />
                  </div>

                  <div className="am-form-group">
                    <label className="am-form-label">End Date (Optional)</label>
                    <input
                      type="date"
                      name="end_date"
                      className="am-form-input"
                      value={formData.end_date}
                      onChange={handleInputChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="am-form-row">
                  <div className="am-form-group">
                    <label className="am-form-label">Link URL (Optional)</label>
                    <input
                      type="text"
                      name="link"
                      className="am-form-input"
                      value={formData.link}
                      onChange={handleInputChange}
                      placeholder="https://example.com or /path"
                      disabled={loading}
                    />
                  </div>

                  <div className="am-form-group">
                    <label className="am-form-label">Link Text</label>
                    <input
                      type="text"
                      name="link_text"
                      className="am-form-input"
                      value={formData.link_text}
                      onChange={handleInputChange}
                      placeholder="Learn More"
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="am-form-group am-form-checkbox">
                  <label className="am-checkbox-label">
                    <input
                      type="checkbox"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleInputChange}
                      disabled={loading}
                    />
                    <Icons.CheckCircle />
                    Active (Show on website)
                  </label>
                </div>

                <div className="am-form-actions">
                  <button type="button" className="am-btn-secondary" onClick={resetForm} disabled={loading}>
                    Cancel
                  </button>
                  <button type="submit" className="am-btn-primary" disabled={loading}>
                    {loading ? 'Saving...' : (editingAnnouncement ? 'Update' : 'Create') + ' Announcement'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnouncementManagement;